export const TABLE_HEADERS = [
    { label: "Name", key: "name" },
    { label: "Product", key: "product" },
    { label: "On-Site Documents Retrieved", key: "onsiteDocuments" },
    { label: "On-site Sessions", key: "onsiteSessions" },
    { label: "On-site Searches", key: "onsiteSearches" },
    { label: "Remote Documents Retrieved", key: "remoteDocuments" },
    { label: "Remote Sessions", key: "remoteSessions" },
    { label: "Remote Searches", key: "remoteSearches" },
    { label: "Individual User Documents Retrieved", key: "individualDocuments" },
    { label: "Individual Sessions", key: "individualSessions" },
    { label: "Individual Searches", key: "individualSearches" },
    { label: "Total Documents Retrieved", key: "totalDocuments" },
    { label: "Total Sessions", key: "totalSessions" },
    { label: "Total Searches", key: "totalSearches" },
];